import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')
const Display = () => import('./views/Display')

export const EMES_FILMS_ROLES = [TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR]

export function createRoutes(options) {
  return [
    route('list/', List, 'profile:emes-films:list', {
      meta: { accessConfig: accessPermission(EMES_FILMS_ROLES, options) },
    }),
    route(':id/', Display, 'profile:emes-films:display', {
      props: true,
      meta: { accessConfig: accessPermission(EMES_FILMS_ROLES, options) },
    }),
  ]
}
